import { Injectable } from '@angular/core';

export interface BadgeItem {
  type: string;
  value: string;
}
export interface Saperator {
  name: string;
  type?: string;
}
export interface SubChildren {
  state: string;
  name: string;
  type?: string;
}
export interface ChildrenItems {
  state: string;
  name: string;
  type?: string;
  child?: SubChildren[];
}

export interface Menu {
  state: string;
  name: string;
  type: string;
  icon: string;
  badge?: BadgeItem[];
  saperator?: Saperator[];
  children?: ChildrenItems[];
  group_name?: string
}

const MENUITEMS = [
  {
    state: '',
    name: 'Home',
    type: 'saperator',
    icon: 'av_timer'
  },
  {
    state: 'natureza51',
    name: 'Home',
    type: 'sub',
    icon: 'av_timer',
    group_name:'dashboards',
    children: [
      // { state: 'dashboard1', name: 'Dashboard 1', type: 'link' },
      // { state: 'dashboard2', name: 'Dashboard', type: 'link' },
      { state: 'dashboard-gestor', name: 'Home Gestor', type: 'link'}

    ]
  },
//====================== MENU ORCAMENTO ABERTO =======================   
  {
    state: '',
    name: 'Sist. Orçamentário',
    type: 'saperator',
    icon: 'book',//book
  },
  // { state: 'natureza51/orcamento', name: 'Orçamento', type: 'link', icon:'book' },
  // { state: 'natureza51/headcount', name: 'HeadCount', type: 'link', icon:'book' },
  
  // { state: 'forecast', name: 'forecast', type: 'link' }
//====================== FIM MENU ORCAMENTO ABERTO =======================
//============== MENU ORCAMENTO ANINHADO =================================  
  /*{
    state: 'natureza51',
    name: 'Sist. Orçamentário',
    type: 'sub',
    icon: 'insert_drive_file',
    children: [      
      {
        state: 'consultas',
        name: 'Consultas',
        type: 'subchild',
        icon: 'insert_drive_file',
        subchildren: [
          { state: 'geral', name: 'Consulta Geral', type: 'link' },
        ]
      },
      { state: 'orcamento', name: 'Orçamento', type: 'link' },
      { state: 'headcount', name: 'HeadCount', type: 'link' },
    ]
  },
  //============== FIM MENU ORCAMENTO ANINHADO =================================
  */  
  //================= INICIO MENU CADASTROS =====================================
   {
    state: '',
    name: 'Parâmetros',
    type: 'saperator',
    icon: 'av_timer'
  },
  {
    state: 'natureza51',
    name: 'Cadastros',
    type: 'sub',
    group_name:'cadastros',
    icon: 'insert_drive_file',
    children: [
      { state: 'lista-atividades', name: 'Atividades', type: 'link' },
      { state: 'grupo-empresarial-lista', name: 'Grupo Empresarial', type: 'link'},
      { state: 'cargo', name: 'Cargo', type: 'link' },
      // { state: 'dashboard2', name: 'Dashboard 2', type: 'link' },
      { state: 'lista-centro-custo', name: 'Centro Custo', type: 'link' },
      { state: 'lista-beneficio', name: 'Benefícios', type: 'link' },
      { state: 'lista-conta-contabil', name: 'Conta Contábil', type: 'link' },
      // { state: 'lista-departamento', name: 'Departamento', type: 'link' },
      // { state: 'lista-diretoria', name: 'Diretoria', type: 'link' },
      // { state: 'lista-endereco', name: 'Endereço', type: 'link' },
      
      // { state: 'lista-setores', name: 'Setores', type: 'link' },
      // { state: 'lista-tela', name: 'Tela', type: 'link' },
      { state: 'lista-despesas', name:'Despesas', type:'link'},
      { state: 'evento', name: 'Eventos', type: 'link' },
      { state: 'lista-turno', name: 'Turno', type: 'link' },
      { state: 'lista-turma', name: 'Turma', type: 'link' },
      { state: 'lista-lotacao', name: 'Lotação', type: 'link'},
      { state: 'lista-plano-lotacao', name: 'Plano Lotação', type: 'link'},
      { state: 'lista-plano-lotacao-tipo', name: 'Tipo Plano Lotação', type: 'link'},
      // { state: 'lista-plano-lotac-unid', name: 'Plano Lotac. Unid', type: 'link' },
      { state: 'lista-funcionario', name: 'Funcionário', type: 'link' },
      { state: 'lista-usuario', name: 'Usuário', type: 'link' },
      { state: 'lista-fgts', name: 'FGTS', type: 'link' },


      //{ state: 'orcamento', name: 'Orçamento', type: 'link' },

      //{ state: 'lista-unidade-medida', name: 'Unidade Medida', type: 'link' },
      { state: 'lista-ccusto-lotacao', name: 'C. Custo x Lotação', type: 'link' },
      //{ state: 'lista-naturezas-ccusto', name: 'Natureza x C. Custo', type: 'link' },
      { state: 'ajustes-salariais', name: 'Cargo x Lotação', type: 'link' },
      { state: 'lista-evento-natureza', name: 'Natureza x Evento', type: 'link' },
      { state: 'lista-parametros', name: 'Parâmetros', type: 'link' },
      { state: 'menu-listar', name: 'Menu', type: 'link' },    
      { state: 'perfil-regras-lista', name: 'Perfil', type: 'link' },
      { state: 'permissoes-lista', name: 'Permissões', type: 'link' },


      { state: 'lista-modulos', name: 'Módulos', type: 'link' },
      { state: 'empresa-lista', name: 'Empresa', type: 'link' },
      { state: 'modulo-permissoes-lista', name: 'Módulo x Permissões', type: 'link' },
      { state: 'lista-modulos-empresa', name: 'Módulo x Empresa', type: 'link' },
    ]
  },
  //================= FIM MENU CADASTROS =====================================
  {
  state: 'insti',
  name: 'insti',
  type: 'sub',
  icon: 'perm_contact_calendar',
  children: [
    { state: 'login', name: 'Login', type: 'link' },
    ]
  }
  
 
];

@Injectable()
export class MenuItems {
  getMenuitem(): Menu[] {
    return MENUITEMS;
  }
}

